export default __webpack_public_path__ + "static/media/stars.5e9c0c8d.svg";